import { createContext, useContext, useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { API_BASE } from "../utils/api";

const UserContext = createContext();
export const useUser = () => useContext(UserContext);

const PUBLIC_ROUTES = ["/nyafaz-brand", "/verify", "/nyafaz-brand/set-password"];

function isPublicBrandRoute(pathname) {
  if (pathname === "/nyafaz-brand" || pathname === "/nyafaz-brand/") {
    return true;
  }
  if (pathname.startsWith("/verify")) {
    return true;
  }
  if (pathname.includes("/set-password")) {
    return true;
  }
  return PUBLIC_ROUTES.some((route) => pathname.startsWith(route));
}

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const isPublic = isPublicBrandRoute(location.pathname);

    if (isPublic) {
      setLoading(false);
      return;
    }

    const userId = localStorage.getItem("userId");
    if (!userId) {
      navigate("/nyafaz-brand");
      return;
    }

    // Session JWT is HttpOnly cookie; keep userId only for client UI state.
    setToken(userId);

    fetch(`${API_BASE}/user/${userId}`, {
      credentials: "include",
      headers: { "Content-Type": "application/json" },
    })
      .then((res) => {
        if (!res.ok) throw new Error("Failed to fetch user");
        return res.json();
      })
      .then((data) => {
        setUser(data);
        setLoading(false);
      })
      .catch(() => navigate("/nyafaz-brand"));
  }, [navigate, location.pathname]);

  return (
    <UserContext.Provider value={{ user, token, loading }}>
      {children}
    </UserContext.Provider>
  );
};
